import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import AdminDashboardLayout from "../AdminDashboardLayout";
import { getAdminDetails } from "../CommonApiCall/getAdminDetails";
import AdminPreviousAdvice from "./AdminPreviousAdvice";
import AdminPreviousAdviceOne from "./AdminPreviousAdviceOne";

const AdminPreviousAdvicePage = () => {
  const { fileName } = useParams();
  const adminDetailsString = localStorage.getItem("userDetails");
  const adminDetails = adminDetailsString
    ? JSON.parse(adminDetailsString)
    : null;
  const adminEmail = adminDetails ? adminDetails.email : null;

  const [data, setData] = useState();

  useEffect(() => {
    if (adminEmail) {
      getAdminDetails(adminEmail)
        .then((fetchedData) => {
          setData(fetchedData);
        })
        .catch((err) => console.log(err));
    }
  }, [adminEmail]);

  const userId = data && data?._id;
  const advisorName = data && data?.advisorName;
  const advisorSpecifier = data && data?.advisorSpecifier;
  const adminRationale = data && data?.rationale;
  return (
    <AdminDashboardLayout>
      {process.env.REACT_APP_PREVIOUS_ADVICE === "1" ? (
        <AdminPreviousAdviceOne
          fileName={fileName}
          userId={userId && userId}
          adminEmail={adminEmail && adminEmail}
          advisorName={advisorName && advisorName}
          advisorSpecifier={advisorSpecifier}
          adminRationale={adminRationale}
        />
      ) : (
        <AdminPreviousAdvice
          fileName={fileName}
          userId={userId && userId}
          adminEmail={adminEmail && adminEmail}
          advisorName={advisorName && advisorName}
          advisorSpecifier={advisorSpecifier}
        />
      )}
    </AdminDashboardLayout>
  );
};

export default AdminPreviousAdvicePage;
